import React from 'react';
import { useRecoilValue } from 'recoil';
import Span from '../../../../common/text/Span';
import { BLACK, GRAY } from '../../../../../styles/constants/color';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';

/**
 *  타금융사 할부조건 선수율(소수점) 로직 컴포넌트
 */
function OtherBankAdvanceReceivedFullRate(): JSX.Element {
  // selected
  const value: number = useRecoilValue(
    otherBankInfoState({ name: 'otherBankAdvanceReceivedFullRate' })
  ); // 선수율(소수점)
  const principalType: string = useRecoilValue(
    otherBankInfoState({ name: 'otherBankPrincipalType' })
  ); // 원금 타입
  const text: string = `(${Math.floor(value * 100) / 100}%)`;
  return (
    <Span fontSize='10px' color={principalType === 'advanceReceivedRate' ? BLACK : GRAY}>
      {text}
    </Span>
  );
}

export default OtherBankAdvanceReceivedFullRate;
